import store from '../../../helpers/store';
import { LAYERS } from '../../layers/types';

const getRedirectUrl = layer => {
    let redirectUrl;
    const state = store.getState();
    switch (layer) {
        case LAYERS.WIDGET:
            if (state.config && state.config.widget && state.config.widget.redirectOnCloseUrl) {
                redirectUrl = state.config.widget.redirectOnCloseUrl;
            }
            break;
        case LAYERS.POPUP:
            if (state.config && state.config.popup && state.config.popup.length > 0) {
                redirectUrl = state.config.popup[0].redirectOnCloseUrl
                    ? state.config.popup[0].redirectOnCloseUrl
                    : null;
            }
            break;
        default:
            break;
    }

    return redirectUrl;
};

export default getRedirectUrl;
